import IFeatureController from "../IFeatureController";
import emitter from "@webcore/core/events/eventemitter";
import { Main } from "@/main.app";

class VideoRecorderController implements IFeatureController {
  private app: Main;

  constructor(app: Main) {
    this.app = app;
  }

  public init() {
    this.setupRecordingEventHandlers();
  }

  public initialize() {
    // Call initialization functions here
  }

  private setupRecordingEventHandlers(): void {
    // Hook up recorder completed and error events
    emitter.on('record-started', () => {
      if (this.app.getMediaRecorder()) {
        this.app.getMediaRecorder().recordVideo({
          onStart: () => {},
          onError: (error: any) => {
            console.error('Media recorder error:', error);
            emitter.emit('record-error', error.message || 'Recording failed');
          },
          onVideoReady: (result: any) => {
            if (result && result.videoBlob) {
              const videoUrl = URL.createObjectURL(result.videoBlob);
              emitter.emit('record-completed', videoUrl);
            } else {
              console.error('Media recorder video ready error');
              emitter.emit('record-error', 'No video data available');
            }
          }
        });
      } else {
        console.error('Media recorder not available');
        emitter.emit('record-error', 'Media recorder not available');
      }
    });

    emitter.on('record-stopped', async () => {
      if (this.app.getMediaRecorder()) {
        try {
          await this.app.getMediaRecorder().stopRecording();
        } catch (error) {
          console.error('Error stopping recording:', error);
          emitter.emit('record-error', 'Failed to stop recording');
        }
      }
    });
  }
}
export default VideoRecorderController;